import React from 'react';
import Header from '../../../Components/DoctorComponents/Header/Header';
import Footer from '../../../Components/DoctorComponents/Footer/Footer';
import Slots from '../../../Components/DoctorComponents/Slots/Slots';

const DoctorSlotsPage = () => {
  return (
    <div>
        <Header/>
        <Slots/>
        <Footer/>
    </div>
  );
};
export default DoctorSlotsPage;